import React from 'react';
import PropTypes from 'prop-types';
import './DayButton.css';

// todo - make functional -> wrap into container
// todo - is importing assets like 'icoDaySelect' good idea

class DayButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
  }

  // -------------------------------------------------------
  // Handlers
  // -------------------------------------------------------

  handleDayClick() {
    const { onDaySelect, dayData } = this.props;
    onDaySelect(dayData.day);
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { dayData } = this.props;
    let classBase = 'day-block';

    // empty box
    if (dayData.day < 1) {
      return <div className={`${classBase} empty`}>-</div>;
    }

    // date boxes
    classBase = `${classBase} ${dayData.sunday ? 'sunday' : ''} ${
      dayData.actual ? 'actual' : ''
    }`;
    // inactive
    if (!dayData.active) {
      return <div className={`${classBase} inactive`}>{dayData.day}</div>;
    }
    // date button
    return (
      <button className={classBase} onClick={this.handleDayClick}>
        {dayData.day}
      </button>
    );
  }
}

DayButton.propTypes = {
  onDaySelect: PropTypes.func.isRequired,
  dayData: PropTypes.object.isRequired
};

export default DayButton;



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/DaySelect/DayButton/DayButton.js